import React, { useEffect } from "react";
import { Checkbox, Col, Divider, Form, InputNumber, Modal, Row, Select } from "antd";
import styles from "../../../../assets/styles/styles";
import { BOM } from "../../../../services/definedMethod";
import { chargeLabel, chargeStatic } from "../charge.config";

const ChargeSlabModal = ({ open, mode = "add", initialValues, onCancel, onSubmit }) => {
  const [form] = Form.useForm();
  const isEditMode = mode === "edit";

  useEffect(() => {
    if (!open) {
      return;
    }

    if (isEditMode && initialValues) {
      form.setFieldsValue({
        fromAmount: initialValues.fromAmount,
        toAmount: initialValues.toAmount,
        consumeLimits: Boolean(initialValues.consumeLimits),
        flatOrPercentage: initialValues.flatOrPercentage,
        amount: initialValues.amount,
      });
      return;
    }

    form.resetFields();
  }, [open, isEditMode, initialValues, form]);

  const handleCancel = () => {
    form.resetFields();
    onCancel?.();
  };

  const handleFinish = (values) => {
    onSubmit?.(values);
    form.resetFields();
  };

  return (
    <Modal
      title={isEditMode ? chargeLabel.editChargeSlab : chargeLabel.addChargeSlab}
      open={open}
      okText={isEditMode ? "Update" : "Add"}
      cancelText="Cancel"
      okButtonProps={{
        autoFocus: true,
        htmlType: "submit",
        style: {
          ...styles.ofPrimaryBtnColor,
        },
      }}
      centered
      onCancel={handleCancel}
      width={800}
      destroyOnClose
      modalRender={(dom) => (
        <Form form={form} layout="vertical" onFinish={handleFinish} name="charge-slab-form">
          {dom}
        </Form>
      )}
    >
      <Divider />
      <Row>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={chargeLabel.fromAmount}
            name="fromAmount"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(chargeLabel.fromAmount),
              },
            ]}
          >
            <InputNumber
              placeholder={BOM.handlePlaceholderMsg(chargeLabel.fromAmount)}
              style={{ width: "100%", ...styles.ofInputFieldNumber }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={chargeLabel.toAmount}
            name="toAmount"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(chargeLabel.toAmount),
              },
            ]}
          >
            <InputNumber
              placeholder={BOM.handlePlaceholderMsg(chargeLabel.toAmount)}
              style={{ width: "100%", ...styles.ofInputFieldNumber }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={chargeLabel.flatOrPercentage}
            name="flatOrPercentage"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(chargeLabel.flatOrPercentage),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(`${chargeLabel.flatOrPercentage} *`, "select")}
              options={chargeStatic.flatOrPercentageOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={chargeLabel.amount}
            name="amount"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(chargeLabel.amount),
              },
            ]}
          >
            <InputNumber
              placeholder={BOM.handlePlaceholderMsg(chargeLabel.amount)}
              style={{ width: "100%", ...styles.ofInputFieldNumber }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="consumeLimits"
            valuePropName="checked"
            initialValue={false}
            // style={{ marginTop: 30 }}
          >
            <Checkbox>{chargeLabel.consumeLimits}</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Modal>
  );
};

export default ChargeSlabModal;
